import { Dialog, Stack, Text, Box } from '@machobear/design-system'
import { useTranslation } from 'react-i18next'

type CreditCheckDialogProps = {
  open: boolean
  onClose: () => void
}

export const CreditCheckDialog = ({ open, onClose }: CreditCheckDialogProps) => {
  const { t } = useTranslation()
  return (
    <Dialog
      id="credit-check-dialog"
      width="small"
      open={open}
      onClose={onClose}
      title="Credit Check"
    >
      <Stack space="large">
        <Text>
          {t(
            'l.standalone_trustscore.list.credit_check_modal.see_following',
            'Please see the following for more information about each status.'
          )}
        </Text>
        <Box width="full" display="flex" flexDirection="row">
          <Box style={{ width: '150px' }} display="flex" flexDirection="column">
            <Box padding="xsmall" background="neutralLight" borderBottom="borderNeutralLight">
              <Text size="small" weight="strong">
                {t('l.standalone_trustscore.list.credit_check_modal.status', 'Status')}
              </Text>
            </Box>
            <Box paddingY="small" paddingX="xsmall" borderBottom="borderNeutralLight">
              <Text> {t('l.standalone_trustscore.list.credit_check_modal.draft', 'Draft')}</Text>
            </Box>
            <Box paddingY="small" paddingX="xsmall" borderBottom="borderNeutralLight">
              <Text>{t('l.standalone_trustscore.list.credit_check_modal.expired', 'Expired')}</Text>
            </Box>
            <Box paddingY="small" paddingX="xsmall" borderBottom="borderNeutralLight">
              <Text>{t('l.standalone_trustscore.list.credit_check_modal.pending', 'Pending')}</Text>
            </Box>
            <Box paddingY="small" paddingX="xsmall" borderBottom="borderNeutralLight">
              <Text>{t('l.standalone_trustscore.list.credit_check_modal.success', 'Success')}</Text>
            </Box>
            <Box paddingY="small" paddingX="xsmall" borderBottom="borderNeutralLight">
              <Text>{t('l.standalone_trustscore.list.credit_check_modal.failed', 'Failed')}</Text>
            </Box>
          </Box>
          <Box width="full" display="flex" flexDirection="column">
            <Box padding="xsmall" background="neutralLight" borderBottom="borderNeutralLight">
              <Text size="small" weight="strong">
                {t('l.standalone_trustscore.list.credit_check_modal.description', 'Description')}
              </Text>
            </Box>
            <Box paddingY="small" paddingX="xsmall" borderBottom="borderNeutralLight">
              <Text>
                {t(
                  'l.standalone_trustscore.list.credit_check_modal.draft_description',
                  'Trust Score form not yet submitted'
                )}
              </Text>
            </Box>
            <Box paddingY="small" paddingX="xsmall" borderBottom="borderNeutralLight">
              <Text>
                {t(
                  'l.standalone_trustscore.list.credit_check_modal.expired_description',
                  'Draft Trust Score form inactive for 3 months'
                )}
              </Text>
            </Box>
            <Box paddingY="small" paddingX="xsmall" borderBottom="borderNeutralLight">
              <Text>
                {t(
                  'l.standalone_trustscore.list.credit_check_modal.pending_description',
                  'Trust Score processing, pending credit check'
                )}
              </Text>
            </Box>
            <Box paddingY="small" paddingX="xsmall" borderBottom="borderNeutralLight">
              <Text>
                {t(
                  'l.standalone_trustscore.list.credit_check_modal.success_description',
                  'Credit check successful, results returned'
                )}
              </Text>
            </Box>
            <Box paddingY="small" paddingX="xsmall" borderBottom="borderNeutralLight">
              <Text>
                {t(
                  'l.standalone_trustscore.list.credit_check_modal.failed_description',
                  'Credit check unsuccessful, please resubmit'
                )}
              </Text>
            </Box>
          </Box>
        </Box>
      </Stack>
    </Dialog>
  )
}
